import React, { Component } from 'react';
import { Button, Progress } from 'reactstrap';
import FontAwesome from 'react-fontawesome';
import Logic from '../../Logic';
import ValidatedLabel from '../ValidatedLabel/ValidatedLabel';

import styles from './FileUpload.css';

class FileUpload extends Component{

    constructor(props) {
        super(props);
        this.state = {
            baseUrl: window.location.hostname === 'localhost' ? 'http://apps/ReliabilityCheck/' : process.env.PUBLIC_URL
        };
    }

    uploadFile(){
        let files = { 
            files: document.getElementById(this.props.fileData.NameEng).files, 
            fileType: this.props.fileData.NameEng
        };
        this.props.uploadAction(files)
    }
    
    render(){
        let logic = new Logic();
        let file = null;
        let uploadButton = (<>
            <input type="file" name={this.props.fileData.NameEng} 
                id={this.props.fileData.NameEng}
                onChange={() => this.uploadFile()}
                multiple={false}
                className="inputFile"/>
            <label className="inputFileLabel" for={this.props.fileData.NameEng}>
                <FontAwesome name="fas fa-upload"/> בחר
            </label>
            {/* <Button className="btn-sm" color="primary" onClick={() => this.uploadFile()}><FontAwesome name="file-upload"/> העלה</Button> */}
        </>);
        let actions = (uploadButton);
        let deleteButton = (<Button className="btn-sm deleteButton" color="link" onClick={() => this.props.deleteAction(file.Id)}><FontAwesome name="trash-alt"/> מחק</Button>);
        let fileStatus = "";
        let fileName = "";
        let fileDate = "";
        let fileSize = "";
        let fileType = this.props.fileData.NameEng;
        if(this.props.uploadData.Attachments !== null){
            let fileArr = this.props.uploadData.Attachments.filter(function(element){
                return element.FileType.NameEng === fileType
            });
            if(fileArr.length > 0){
                file = fileArr[0];
            }
            if(file !== null){
                fileName = file.Name;
                switch (file.Status) {
                    case 0: //processing
                        fileDate = (<Progress animated value="100" className="progressBar"></Progress>);
                        fileStatus = "בתהליך";
                        actions = (deleteButton);
                        break;
                    case 1: //ok
                        fileDate = logic.formatDate(file.UploadAt);
                        fileStatus = "עלה בהצלחה";
                        fileName = (<a href="#" onClick={() => this.props.downloadAction(file.Id)}>{file.Name}</a>);
                        actions = (deleteButton);
                        fileSize = (file.Size / 1024).toFixed(2);
                        break;
                    case 3: //error
                        fileDate = (<Progress animated value="100" color="danger" className="progressBar"></Progress>);
                        fileStatus = "ארעה שגיאה מחק ונסה שנית";
                        fileSize = (file.Size / 1024).toFixed(2);
                        actions = (deleteButton);
                        break;
                    default:
                        break;
                }
            }
        }
        let fileDetails = (<>
            <div className={fileName !== null && fileName !== "" ? "col col-md-3 col-12" : "col col-md-3 col-12 d-none d-md-block"}><label className="d-inline d-md-none cardLabel">שם:</label>{fileName}</div>
            <div className={fileName !== null && fileName !== "" ? "col col-md-2 col-12" : "col col-md-2 col-12 d-none d-md-block"}><label className="d-inline d-md-none cardLabel">סטאטוס:</label>{fileStatus}</div>
            <div className={fileName !== null && fileName !== "" ? "col col-md-1 col-12" : "col col-md-1 col-12 d-none d-md-block"}><label className="d-inline d-md-none cardLabel">גודל MB:</label>{fileSize}</div>
            <div className={fileName !== null && fileName !== "" ? "col col-md-2 col-12" : "col col-md-2 col-12 d-none d-md-block"}><label className="d-inline d-md-none cardLabel">תאריך העלאה:</label>{fileDate}</div>
            <div className="col col-md-1 col-12"><label className="d-inline d-md-none cardLabel">פעולות:</label>{actions}</div>
        </>)
        return (
            <div className="card" style={{marginBottom:'20px'}}>
                <div className="card-body">
                    <div className="row">
                        <div className="col col-md-3 col-12">
                            <ValidatedLabel label={this.props.fileData.Name} name={this.props.fileData.NameEng} required={this.props.required} cols="12" className="fileTypeLabel" groupClassName="labelGroup" />
                            {this.props.fileData.LinkToEmptyFile !== null ? 
                                <a href={this.state.baseUrl + this.props.fileData.LinkToEmptyFile} target="_blank">להורדת טופס ריק</a> : 
                                ""}
                        </div>
                        {fileDetails}
                    </div>
                </div>
            </div>);
    }
    
  };
  
  export default FileUpload;
  